import { render } from "./PromoCode.vue?vue&type=template&id=0a4ef741&scoped=true&ts=true"
import script from "./PromoCode.vue?vue&type=script&lang=ts"
export * from "./PromoCode.vue?vue&type=script&lang=ts"

import "./PromoCode.vue?vue&type=style&index=0&id=0a4ef741&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4ef741"]])

export default __exports__